(() => {
  const end = Date.parse('2026-10-19T00:00:00+02:00');
  const hideExpiredCampaign = () => {
    if (Date.now() < end) return;
    document.querySelectorAll('[data-vrww-campaign]').forEach((element) => {
      element.hidden = true;
      element.style.display = 'none';
    });
  };
  hideExpiredCampaign();
  setInterval(hideExpiredCampaign, 1000);
  document.addEventListener('visibilitychange', hideExpiredCampaign);
  document.addEventListener('shopify:section:load', hideExpiredCampaign);
})();
